import "dayjs/locale/ka";
import "dayjs/locale/en";
import { useTranslation } from "react-i18next";
import ButtonComponent from "../buttonComponent/ButtonComponent";
import { Box } from "@mui/material";

function CustomCalendarPickerActionBar({ onAccept, actions, ...props }) {
  const { t } = useTranslation();

  if (!actions.includes("accept")) {
    return null;
  }

  return (
    <Box display="flex" justifyContent="flex-end" p={2} {...props}>
      <ButtonComponent onClick={onAccept} text={t("ok")} className="p-3" />
    </Box>
  );
}

export default CustomCalendarPickerActionBar;
